import usePost from "../../customhooks/UsePost"
import { Trans, useTranslation } from "react-i18next";
import { useToaster, Notification, Popover, Whisper } from "rsuite";
import { useSearchParams } from "react-router-dom";
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { Col, Row } from "react-bootstrap";
import ToasterNotification from "../../utilities/ToasterNotification";
import {toast} from "react-toastify"

export default function ResendMail({
    interviewID,
    companyID,
    roundNumber,
    slotID,
    clientID,
    companySupportEmail
}) {
    const reCaptchaSiteKey = import.meta.env.VITE_RECAPTCHASITE_KEYY
    const toaster = useToaster();
    const { t } = useTranslation()
    let [searchParams] = useSearchParams();
    const triggerRef = React.useRef();
    const open = () => triggerRef.current.open();
    const close = () => triggerRef.current.close();
    const [defaultOptions, setDefaultOptions] = React.useState({
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        pauseOnFocusLoss: false
    })

    // usePost
    const {
        post: resendMail,
        data: resendMailData,
        isLoading: resendMailLoading,
        error: resendMailError,
    } = usePost("/schedulevideo/resendAutoScheduleMail");

    const handleResendMail = () => {
        // {
        //     "companyID": "552d016291bad07ccbb455fe",
        //     "interviewID": "650c161f7460c889d6023323",
        //     "event": "Request-Schedule-AsNew",
        //     "clientID": "5fb276fa123f55bd44e1569d",
        //     "screeningRoundNumber": "2",
        //     "realTime": true,
        //     "previousSlot": "",
        //     "slotID": "650c1668148a4f49647c6564"
        // }

        let apiObj;
        if (searchParams.get("rid") !== null) {
            apiObj = {
                companyID: companyID,
                clientID: clientID,
                slotID: slotID,
                resumeID: searchParams.get("rid") ?? "",
                participant: searchParams.get("participant") !== null ? searchParams.get("participant") : "",
                userID: searchParams.get("uid") ?? ""
            }
        } else {
            apiObj = {
                companyID: companyID,
                interviewID: interviewID,
                // event: "Request-Schedule-AsNew",
                clientID: clientID,
                screeningRoundNumber: roundNumber,
                // previousSlot: "",
                slotID: slotID,
                // resumeID: resumeID,
                participant: searchParams.get("participant") !== null ? searchParams.get("participant") : ""
            }
        }

        resendMail(apiObj)
            .then((response) => {
                // console.log("response", response);

                if (response?.status) {
                    if (response?.result?.status) {
                        // toaster.push(
                        //     <Notification type={"success"} header={t("success", { defaultValue: "success" })}>
                        toast.success(
                            <div className="m-1">
                                <p className="m-0 p-0">
                                    {
                                        t("calendarInviteHasBeenSentToYourEmailAddress.PleaseCheckYourE-mailInboxOrSpamFolder.ThankYou!",
                                            { defaultValue: "Calendar invite has been sent to your email address. Please check your E-mail Inbox or Spam folder. Thank You!" }
                                        )
                                    }
                                </p>
                                <p className="m-0 p-0">
                                    <b>
                                        {
                                            t("ifYouHaveNotReceivedIt,PleaseSendOutAnEmailTo", { defaultValue: "If you have not received it, please send out an email to" })
                                        }
                                        {" "}{companySupportEmail}
                                    </b>
                                </p>
                            </div>, defaultOptions
                            )
                        //     </Notification>,
                        //     { placement: "topEnd" },
                        // );
                    } else {
                        // toaster.push(
                        //     <Notification type={"error"} header={t("error", { defaultValue: "error" })}>
                        //         {
                        //             t("pleaseContactSupportTeam", { defaultValue: "Please contact Support Team" })
                        //         }
                        //     </Notification>,
                        //     { placement: "topEnd" },
                        // );
                        ToasterNotification({
                            type: "error",
                            i18keyFormat: "pleaseContactSupportTeam",
                            message: "Please contact Support Team",
                            options: { position: "top-right", autoClose: 5000 },
                        });
                    }
                } else {
                    // toaster.push(
                    //     <Notification type={"error"} header={t("error", { defaultValue: "error" })}>
                    //         {
                    //             t("somethingWentWrongPleaseTryAgainLater", { defaultValue: "Something went wrong.Please try again later" })
                    //         }
                    //     </Notification>,
                    //     { placement: "topEnd" },
                    // );
                    ToasterNotification({
                        type: "error",
                        i18keyFormat:"somethingWentWrongPleaseTryAgainLater",
                        message: "Something went wrong.Please try again later",
                        options: { position: "top-right", autoClose: 5000 },
                    });
                }
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

    const onChange = (value) => {
        if (value) {
            setTimeout(() => {
                close()
            }, 1000)
            handleResendMail()
        }
    }

    return (
        <>
            <Whisper
                placement="auto"
                // trigger="click"
                ref={triggerRef}
                trigger="click"
                speaker={
                    <Popover>
                        <Row>
                            <Col>
                                <ReCAPTCHA
                                    sitekey={reCaptchaSiteKey}
                                    onChange={onChange}
                                />
                            </Col>
                        </Row>
                    </Popover>
                }
            >
                <span
                    className="fs-6 text-decoration-none  resend-text"
                    // onClick={() => handleResendMail()}
                    onClick={open}
                >
                    <Trans i18nKey="resendMail" defaults="Resend Mail" />
                </span>
            </Whisper>
        </>
    )
}